<template>
  <div class="pages-wrapper container">
    <pages-side-bar
      class="side-nav"
    />

    <div class="content html-content">
      <slot />
    </div>
  </div>
</template>

<script>

import PagesSideBar from './pages-side-bar';

export default {
  name: 'pages-wrapper',

  components: {
    PagesSideBar,
  },

  data() {
    return {
      //
    }
  },
};
</script>

<style lang="scss">
.pages-wrapper {
  & > .content {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 20px;

    h1 {
      margin-top: 24px;
    }

    h4 {
      font-size: 16px;
      line-height: 24px;
    }

    .ui-tabs {
      margin-top: 24px;
    }

    .banner {
      display: flex;
      flex-direction: column;
      margin-top: 24px;

      .banner-image {
        position: relative;
        width: 100%;
        height: 220px;
        background: #e0e0e0;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .banner-info {
        display: flex;
        flex-wrap: wrap;
        height: 100%;
        background-color: $blue;
        color: #fff;
        padding: 24px;

        h4,
        p {
          width: 100%;
        }

        h4 {
          margin: 0;
        }

        p {
          margin-top: 8px;
        }

        ul {
          li::before {
            background-color: #fff;
          }
        }
      }

      .banner-buttons {
        display: flex;
        width: 100%;
      }

      .info-button {
        display: block;
        width: 100%;
        margin-top: 24px;
        padding: 7px 16px;
        color: $black;
        font-weight: bold;
        font-size: 14px;
        line-height: 24px;
        background-color: #fff;
        border-radius: 4px;
        border: 1px solid $gray_lu;
        text-align: center;

        &:not(:first-child) {
          margin-left: 12px;
        }
      }
    }

    .row-banner {
      display: flex;
      align-items: flex-start;
      padding: 16px;
      margin-top: 24px;
      color: #fff;
      background-color: $purple_l;
      font-size: 16px;
      line-height: 24px;
      font-weight: 600;

      & > img {
        display: none;
      }
    }

    .advantages {
      display: flex;
      flex-wrap: wrap;
      margin-top: 16px;

      li {
        display: flex;
        flex-direction: row-reverse;
        align-items: flex-start;
        justify-content: space-between;
        width: 100%;
        margin-top: 0;
        padding: 16px;
        border: 1px solid $gray_lu;
        border-bottom: 0;
      }

      li:last-child {
        border-bottom: 1px solid $gray_lu;
      }

      li::before {
        display: none;
      }

      &-icon {
        display: flex;
        justify-content: center;
        align-items: center;
        min-width: 56px;
        min-height: 56px;
        background-color: $blue;
        border-radius: 4px;

        img {
          width: 32px;
          height: 32px;
        }
      }

      &-text {
        display: flex;
        flex-direction: column;

        span {
          font-size: 12px;
          line-height: 20px;
        }

        p {
          margin-top: 8px;
          margin-right: 12px;
          font-size: 16px;
          line-height: 20px;
          font-weight: 600;
        }
      }
    }
  }
}

@include breakpoint("tablet") {
  .pages-wrapper {
    & > .content {
      .banner {
        flex-direction: row;
        height: 268px;
        margin-top: 24px;

        .banner-image,
        .banner-info {
          width: 50%;
          height: 100%;
        }

        .banner-info {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          padding: 24px;
        }

        .banner-buttons {
          width: auto;
          margin-top: auto;
        }

        .info-button {
          width: auto;
          margin-top: auto;
        }

        &.reverse {
          flex-direction: row-reverse;
        }
      }

      .row-banner {
        padding: 24px;
      }

      .advantages {
        flex-wrap: nowrap;
        margin-top: 24px;

        li {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          flex-grow: 1;
          padding: 24px 24px 20px;
          border-right: 0;
          border-bottom: 1px solid $gray_lu;
        }

        li:last-child {
          border-right: 1px solid $gray_lu;
        }

        li::before {
          display: none;
        }

        &-text {
          margin-top: 16px;

          p {
            margin-right: 0;
          }
        }
      }
    }
  }
}

@include breakpoint("desktop") {
  .pages-wrapper {
    display: flex;

    & > .content {
      h1 {
        margin-top: 32px;
      }

      h4 {
        font-size: 20px;
        line-height: 28px;
      }

      .ui-tabs {
        margin-top: 32px;
      }

      .banner {
        height: 340px;
        margin-top: 32px;

        .banner-info {
          padding: 40px;

          p {
            margin-top: 16px;
          }
        }
      }

      .row-banner {
        display: flex;
        align-items: center;
        margin-top: 32px;
        padding: 40px;
        font-size: 20px;
        line-height: 28px;

        & > img {
          display: block;
          width: 40px;
          height: 40px;
          margin-right: 16px;
        }
      }

      .advantages {
        margin-top: 32px;

        &-text {
          margin-top: 20px;

          span {
            font-size: 16px;
            line-height: 24px;
          }

          p {
            font-size: 20px;
            line-height: 28px;
          }
        }

        &-icon {
          width: 80px;
          height: 80px;

          img {
            width: 40px;
            height: 40px;
          }
        }
      }
    }

    & > .side-nav {
      min-width: 248px;
      margin-right: 64px;
    }
  }
}
</style>